/* ============================================================
   TRPN — ROUE DE LA FORTUNE
   Aucune dépendance. Tout est piloté par les attributs data-*
   posés par sections/trpn-wheel.liquid.

   Limite assumée : le tirage se fait dans le navigateur. Les lots
   et les codes sont donc lisibles dans le source de la page. La
   protection réelle est la limite d'usage posée sur chaque code
   dans l'admin Shopify, pas le secret du tirage.
   ============================================================ */
(function () {
  "use strict";

  var STORAGE_KEY = "trpn-wheel";

  /* ----------------------------------------------------------
     Mémoire locale — tolérante aux navigateurs qui la bloquent
     ---------------------------------------------------------- */
  function readState() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    } catch (e) {
      return null;
    }
  }

  function writeState(value) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (e) {
      /* navigation privée, stockage refusé : on laisse jouer */
    }
  }

  /* ----------------------------------------------------------
     Tirage pondéré
     ---------------------------------------------------------- */
  function draw(segments) {
    var total = segments.reduce(function (sum, s) {
      return sum + s.weight;
    }, 0);
    if (total <= 0) return 0;

    var roll = Math.random() * total;
    var cursor = 0;
    for (var i = 0; i < segments.length; i++) {
      cursor += segments[i].weight;
      if (roll < cursor) return i;
    }
    return segments.length - 1;
  }

  /* ----------------------------------------------------------
     Tracé du disque
     Liquid n'a ni cosinus ni sinus : la géométrie est calculée ici.
     Secteurs égaux — la probabilité ne change pas la taille visuelle,
     sinon les cases rares seraient des fentes illisibles.
     ---------------------------------------------------------- */
  var NS = "http://www.w3.org/2000/svg";
  var R = 96;
  var C = 100;

  function pointOnCircle(angleDeg, radius) {
    var rad = ((angleDeg - 90) * Math.PI) / 180;
    return [C + radius * Math.cos(rad), C + radius * Math.sin(rad)];
  }

  function drawDisc(svg, segments) {
    var step = 360 / segments.length;
    var group = document.createElementNS(NS, "g");

    segments.forEach(function (seg, i) {
      var a0 = i * step;
      var a1 = (i + 1) * step;
      var p0 = pointOnCircle(a0, R);
      var p1 = pointOnCircle(a1, R);
      var largeArc = step > 180 ? 1 : 0;

      var path = document.createElementNS(NS, "path");
      path.setAttribute(
        "d",
        "M" + C + "," + C +
          " L" + p0[0].toFixed(2) + "," + p0[1].toFixed(2) +
          " A" + R + "," + R + " 0 " + largeArc + " 1 " +
          p1[0].toFixed(2) + "," + p1[1].toFixed(2) + " Z"
      );
      path.setAttribute(
        "fill",
        seg.highlight ? "#ffffff" : i % 2 === 0 ? "#133a6e" : "#0e2d59"
      );
      path.setAttribute("stroke", "rgba(255,255,255,0.22)");
      path.setAttribute("stroke-width", "0.6");
      group.appendChild(path);

      // Le libellé suit le rayon médian. Sur la moitié gauche du disque,
      // ce placement le mettrait la tête en bas : on retourne alors le
      // repère de 180° et on ancre le texte de l'autre côté, pour qu'il
      // reste lisible dans les huit secteurs.
      var mid = a0 + step / 2;
      var flipped = mid > 180;
      var text = document.createElementNS(NS, "text");
      text.setAttribute("x", String(flipped ? C - R + 8 : C + R - 8));
      text.setAttribute("y", String(C));
      text.setAttribute(
        "transform",
        "rotate(" + (flipped ? mid + 90 : mid - 90) + " " + C + " " + C + ")"
      );
      text.setAttribute("text-anchor", flipped ? "start" : "end");
      text.setAttribute("dominant-baseline", "middle");
      text.setAttribute("font-family", '"JetBrains Mono", monospace');
      text.setAttribute("font-size", segments.length > 8 ? "5" : "6");
      text.setAttribute("letter-spacing", "0.3");
      text.setAttribute("fill", seg.highlight ? "#133a6e" : "#ffffff");
      text.textContent = seg.label || "";
      group.appendChild(text);
    });

    svg.appendChild(group);
  }

  /* ----------------------------------------------------------
     Une roue
     ---------------------------------------------------------- */
  function initWheel(root) {
    var segments;
    try {
      segments = JSON.parse(
        root.querySelector("[data-trpn-wheel-data]").textContent
      );
    } catch (e) {
      return;
    }
    if (!segments.length) return;

    var overlay = root.querySelector("[data-trpn-wheel-overlay]");
    var disc = root.querySelector("[data-trpn-wheel-disc]");
    var form = root.querySelector("[data-trpn-wheel-form]");
    var emailInput = root.querySelector("[data-trpn-wheel-email]");
    var consent = root.querySelector("[data-trpn-wheel-consent]");
    var stepIntro = root.querySelector('[data-trpn-step="intro"]');
    var stepResult = root.querySelector('[data-trpn-step="result"]');
    var resultTitle = root.querySelector("[data-trpn-result-title]");
    var resultText = root.querySelector("[data-trpn-result-text]");
    var resultCode = root.querySelector("[data-trpn-result-code]");
    var copyBtn = root.querySelector("[data-trpn-copy]");
    var closers = root.querySelectorAll("[data-trpn-wheel-close]");

    var delay = parseInt(root.getAttribute("data-delay"), 10) || 30;
    var exitIntent = root.getAttribute("data-exit-intent") === "true";
    var replayDays = parseInt(root.getAttribute("data-replay-days"), 10) || 30;

    var opened = false;
    var spinning = false;
    var angleStep = 360 / segments.length;

    drawDisc(disc, segments);

    /* — Ouverture / fermeture — */
    function open() {
      if (opened) return;
      opened = true;
      root.setAttribute("data-open", "");
      document.body.style.overflow = "hidden";
      var first = root.querySelector("[data-trpn-wheel-email], [data-trpn-wheel-close]");
      if (first) first.focus({ preventScroll: true });
    }

    function close() {
      root.removeAttribute("data-open");
      document.body.style.overflow = "";
    }

    Array.prototype.forEach.call(closers, function (el) {
      el.addEventListener("click", close);
    });

    if (overlay) {
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) close();
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && root.hasAttribute("data-open")) close();
    });

    /* — Faut-il PROPOSER la roue spontanément ? —
       Attention : cette décision ne conditionne que les déclencheurs
       automatiques. Tout le reste — formulaire, fermeture, tirage — est
       câblé plus haut sans condition, sinon la roue serait inerte si on
       l'ouvrait par un autre moyen (lien, bouton, éditeur de thème). */
    function autoTriggersAllowed() {
      if (new URLSearchParams(location.search).has("no-roue")) return false;

      var state = readState();
      if (state && state.at) {
        var elapsedDays = (Date.now() - state.at) / 86400000;
        if (elapsedDays < replayDays) return false;
      }
      return true;
    }

    if (autoTriggersAllowed()) {
      var timer = setTimeout(open, delay * 1000);

      if (exitIntent) {
        document.addEventListener("mouseout", function onOut(e) {
          if (e.clientY > 0 || e.relatedTarget) return;
          clearTimeout(timer);
          document.removeEventListener("mouseout", onOut);
          open();
        });
      }
    }

    /* — Rotation vers un secteur donné — */
    // Doit rester synchronisé avec la transition de .trpn-wheel__disc
    // dans trpn.css. Le lot est révélé 150 ms après l'arrêt.
    var SPIN_MS = 3600;
    var REVEAL_MS = SPIN_MS + 150;

    function spinTo(index) {
      // Le repère du secteur est son milieu ; on l'amène sous l'aiguille,
      // placée en haut. Quatre tours : au-delà, la roue paraît lente
      // plutôt que rapide, parce qu'elle tourne trop longtemps à vitesse
      // presque nulle en fin de course.
      var mid = index * angleStep + angleStep / 2;
      var target = 360 * 4 - mid;
      disc.style.transform = "rotate(" + target + "deg)";
    }

    /* ----------------------------------------------------------
       Le tour

       Deux chemins, selon le consentement :

       • Case cochée — on laisse le formulaire Shopify partir
         normalement. La page recharge, l'adresse est enregistrée, et
         le tour reprend au retour grâce à `[data-trpn-wheel-resume]`.
         C'est le seul chemin possible : la protection anti-robots de
         Shopify rejette toute soumission fabriquée en JavaScript.

       • Case décochée — on ne soumet rien, donc aucune adresse n'est
         collectée, et le visiteur joue tout de suite. Soumettre ce
         formulaire vaut inscription au marketing : on ne peut pas le
         faire sans accord explicite.
       ---------------------------------------------------------- */
    function runSpin() {
      if (spinning) return;
      spinning = true;
      root.setAttribute("data-spinning", "");

      var index = draw(segments);
      var prize = segments[index];

      spinTo(index);

      setTimeout(function () {
        root.removeAttribute("data-spinning");
        if (stepIntro) stepIntro.hidden = true;
        if (stepResult) stepResult.hidden = false;

        if (resultTitle) resultTitle.textContent = prize.title || prize.label;
        if (resultText) resultText.textContent = prize.text || "";

        if (resultCode) {
          if (prize.code) {
            resultCode.hidden = false;
            resultCode.querySelector("[data-trpn-code-value]").textContent =
              prize.code;
          } else {
            resultCode.hidden = true;
          }
        }

        writeState({ at: Date.now(), prize: prize.label });
      }, REVEAL_MS);
    }

    form.addEventListener("submit", function (e) {
      if (spinning) {
        e.preventDefault();
        return;
      }

      var email = (emailInput.value || "").trim();
      if (!email || email.indexOf("@") < 1) {
        e.preventDefault();
        emailInput.focus();
        return;
      }

      // Sans consentement : aucune collecte, on joue sur place.
      if (!consent || !consent.checked) {
        e.preventDefault();
        runSpin();
        return;
      }

      // Avec consentement : le formulaire part, la page recharge.
      // On mémorise pour rouvrir la roue au retour.
      try {
        sessionStorage.setItem("trpn-wheel-pending", "1");
      } catch (err) {
        /* stockage refusé : la reprise se fera par le marqueur Liquid */
      }
      root.setAttribute("data-spinning", "");
    });

    /* — Reprise après le rechargement — */
    var resumeMark = root.querySelector("[data-trpn-wheel-resume]");
    var resumePending = false;
    try {
      resumePending = sessionStorage.getItem("trpn-wheel-pending") === "1";
      if (resumePending) sessionStorage.removeItem("trpn-wheel-pending");
    } catch (err) {
      /* ignoré */
    }

    if (resumeMark || resumePending) {
      open();
      setTimeout(runSpin, 500);
    }

    /* — Copier le code — */
    if (copyBtn) {
      copyBtn.addEventListener("click", function () {
        var value = resultCode.querySelector("[data-trpn-code-value]").textContent;
        var done = function () {
          var original = copyBtn.textContent;
          copyBtn.textContent = copyBtn.getAttribute("data-copied") || "Copié";
          setTimeout(function () {
            copyBtn.textContent = original;
          }, 2000);
        };
        if (navigator.clipboard) {
          navigator.clipboard.writeText(value).then(done, done);
        } else {
          done();
        }
      });
    }
  }

  function boot(scope) {
    (scope || document)
      .querySelectorAll("[data-trpn-wheel]")
      .forEach(initWheel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target);
  });
})();
